"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProblemOrdersRules = void 0;
const react_1 = __importStar(require("react"));
const Sentry = __importStar(require("@sentry/react"));
const react_bootstrap_1 = require("react-bootstrap");
const client_1 = require("@apollo/client");
const polaris_1 = require("@shopify/polaris");
const polaris_icons_1 = require("@shopify/polaris-icons");
const Offcanvas = __importStar(require("components/general/Offcanvas"));
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
const AccountContext_1 = require("contexts/AccountContext");
const useToast_1 = __importDefault(require("components/general/Toast/useToast"));
const Toast_1 = __importDefault(require("components/general/Toast/Toast"));
const SettingSwitch_1 = require("./SettingSwitch");
const rulesReducer_1 = require("./rulesReducer");
const graphql_1 = require("./graphql");
const styles_1 = require("./styles");
const ProblemOrdersRules = ({ onHide, show }) => {
    const { account } = (0, AccountContext_1.useAccount)();
    const [error, setError] = (0, react_1.useState)(null);
    const [transitIntervalFieldError, setTransitIntervalFieldError] = (0, react_1.useState)(null);
    const [fulfillmentIntervalFieldError, setFulfillmentIntervalFieldError] = (0, react_1.useState)(null);
    const [updating, setUpdating] = (0, react_1.useState)(false);
    const { data: rulesData, loading, refetch: refetchRules } = (0, client_1.useQuery)(graphql_1.GET_RULES_QUERY, {
        variables: account ? { accountId: account.id } : undefined,
        // don't run query until this component is shown
        skip: !show,
        onError: (err) => {
            Sentry.captureException(err);
            setError(err.message);
        }
    });
    const { setToastMessage, toastParams } = (0, useToast_1.default)();
    const [updateRule] = (0, client_1.useMutation)(graphql_1.UPDATE_RULE_MUTATION);
    const [rulesObject, dispatch] = (0, react_1.useReducer)(rulesReducer_1.rulesReducer, null);
    // set rules object to a more manageable and easily searchable structure that
    // we can modify when the form values change
    (0, react_1.useEffect)(() => {
        if (rulesData === null || rulesData === void 0 ? void 0 : rulesData.rules) {
            dispatch({ type: 'SET_RULES', payload: rulesData });
        }
    }, [rulesData === null || rulesData === void 0 ? void 0 : rulesData.rules]);
    const fulfillmentExclusionList = ((rulesObject === null || rulesObject === void 0 ? void 0 : rulesObject.FulfillmentStalled.variables.excludedDaysOfWeek) || []);
    const transitExclusionList = ((rulesObject === null || rulesObject === void 0 ? void 0 : rulesObject.ShipmentStalled.variables.excludedDaysOfWeek) || []);
    const lastScannedIntervalHours = () => {
        const value = rulesObject === null || rulesObject === void 0 ? void 0 : rulesObject.ShipmentStalled.variables.lastScannedIntervalHours;
        return (value || '').toString();
    };
    const firstScannedIntervalHours = () => {
        const value = rulesObject === null || rulesObject === void 0 ? void 0 : rulesObject.FulfillmentStalled.variables.firstScannedIntervalHours;
        return (value || '').toString();
    };
    const handleSubmit = (e) => {
        var _a, _b;
        e.preventDefault();
        if (updating || !rulesObject || !account) {
            return;
        }
        const transitIntervalValue = parseInt((_a = rulesObject.ShipmentStalled.variables.lastScannedIntervalHours) === null || _a === void 0 ? void 0 : _a.toString(), 10);
        const fulfillmentIntervalValue = parseInt((_b = rulesObject.FulfillmentStalled.variables.firstScannedIntervalHours) === null || _b === void 0 ? void 0 : _b.toString(), 10);
        if (!isFinite(transitIntervalValue) || transitIntervalValue < 1) {
            setTransitIntervalFieldError('invalid interval value');
            return;
        }
        if (!isFinite(fulfillmentIntervalValue) || fulfillmentIntervalValue < 1) {
            setFulfillmentIntervalFieldError('invalid interval value');
            return;
        }
        setTransitIntervalFieldError(null);
        setFulfillmentIntervalFieldError(null);
        setError(null);
        setUpdating(true);
        const updates = Object.entries(rulesObject).map(([_key, rule]) => {
            return updateRule({
                variables: {
                    input: {
                        id: rule.id,
                        enabled: rule.enabled,
                        variables: JSON.stringify(rule.variables),
                        accountId: account.id
                    }
                }
            });
        });
        Promise.all(updates)
            .then(() => __awaiter(void 0, void 0, void 0, function* () {
            yield refetchRules();
            setToastMessage('Rules updated!');
        }))
            .catch((err) => {
            Sentry.captureException(err);
            setError(err.message);
        })
            .finally(() => {
            setUpdating(false);
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
        react_1.default.createElement(Offcanvas.Container, { backdrop: false, onHide: onHide, placement: 'end', show: show, style: { maxWidth: '23.75rem' } },
            react_1.default.createElement(Offcanvas.Header, null,
                react_1.default.createElement(polaris_1.DisplayText, { size: 'small' }, "Problem Orders"),
                react_1.default.createElement(polaris_1.Button, { icon: polaris_icons_1.CancelSmallMinor, onClick: onHide, plain: true })),
            react_1.default.createElement(styles_1.GuideContainer, null,
                react_1.default.createElement(polaris_1.TextStyle, null,
                    "Enable the options below to send an event to your integrated apps and view related data in the Problem Orders report.",
                    ' ')),
            react_1.default.createElement(Offcanvas.Body, null,
                error && (react_1.default.createElement(styles_1.ErrorContainer, null,
                    react_1.default.createElement("i", { className: 'fe fe-alert-octagon' }),
                    react_1.default.createElement("p", null, "Sorry, an error has occurred. Our team has been notified. Please refresh the page and try again."))),
                (!error && loading) || !rulesObject ? (react_1.default.createElement(styles_1.LoadingSpinnerContainer, null,
                    react_1.default.createElement(LoadingSpinner_1.default, null))) : (react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: handleSubmit },
                    react_1.default.createElement(styles_1.FormBodyContainer, null,
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(SettingSwitch_1.SettingSwitch, { disabled: updating, id: 'delivery-attempted', label: 'Delivery Attempted', onChange: (value) => dispatch({
                                    type: 'DELIVERY_ATTEMPTED_ENABLED',
                                    payload: value
                                }), value: rulesObject.ShipmentDeliveryAttempted.enabled }),
                            react_1.default.createElement(polaris_1.TextStyle, { variation: 'subdued' }, "A failed delivery attempt occurs")),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(SettingSwitch_1.SettingSwitch, { disabled: updating, id: 'returned-to-sender', label: 'Returned to Sender', onChange: (value) => dispatch({
                                    type: 'RETURN_TO_SENDER_ENABLED',
                                    payload: value
                                }), value: rulesObject.ShipmentReturnedToSender.enabled }),
                            react_1.default.createElement(polaris_1.TextStyle, { variation: 'subdued' }, "An order was not successfully delivered and is en route back to the sender")),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(SettingSwitch_1.SettingSwitch, { disabled: updating, id: 'stalled-fulfillment', label: 'Stalled in Fulfillment', onChange: (value) => dispatch({
                                    type: 'LAST_UPDATE_FULFILLMENT_ENABLED',
                                    payload: value
                                }), value: rulesObject.FulfillmentStalled.enabled }),
                            react_1.default.createElement(polaris_1.TextStyle, { variation: 'subdued' }, "An order that is not yet in transit and has not received an update within a specified timeframe"),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: 'stalled-fulfillment-last-updated' },
                                react_1.default.createElement(styles_1.TextFieldContainer, null,
                                    react_1.default.createElement(polaris_1.TextField, { autoComplete: 'off', disabled: updating, error: fulfillmentIntervalFieldError !== null && fulfillmentIntervalFieldError !== void 0 ? fulfillmentIntervalFieldError : undefined, label: 'Stalled timeframe:', min: 1, onChange: (value) => {
                                            dispatch({
                                                type: 'LAST_UPDATE_FULFILLMENT_INTERVAL',
                                                payload: value
                                            });
                                        }, onFocus: () => setFulfillmentIntervalFieldError(null), suffix: 'hours', type: 'number', value: firstScannedIntervalHours() }))),
                            react_1.default.createElement(styles_1.CheckBoxContainer, null,
                                react_1.default.createElement(polaris_1.Checkbox, { checked: fulfillmentExclusionList === null || fulfillmentExclusionList === void 0 ? void 0 : fulfillmentExclusionList.includes(6), label: 'Exclude Saturdays', onChange: (checked) => {
                                        const actionType = checked
                                            ? 'LAST_UPDATE_FULFILLMENT_ADD_EXCLUSION'
                                            : 'LAST_UPDATE_FULFILLMENT_REMOVE_EXCLUSION';
                                        dispatch({
                                            type: actionType,
                                            payload: 6
                                        });
                                    } }),
                                react_1.default.createElement(polaris_1.Checkbox, { checked: fulfillmentExclusionList === null || fulfillmentExclusionList === void 0 ? void 0 : fulfillmentExclusionList.includes(7), label: 'Exclude Sundays', onChange: (checked) => {
                                        const actionType = checked
                                            ? 'LAST_UPDATE_FULFILLMENT_ADD_EXCLUSION'
                                            : 'LAST_UPDATE_FULFILLMENT_REMOVE_EXCLUSION';
                                        dispatch({
                                            type: actionType,
                                            payload: 7
                                        });
                                    } }))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(SettingSwitch_1.SettingSwitch, { disabled: updating, id: 'stalled-transit', label: 'Stalled in Transit', onChange: (value) => dispatch({
                                    type: 'LAST_UPDATE_TRANSIT_ENABLED',
                                    payload: value
                                }), value: rulesObject.ShipmentStalled.enabled }),
                            react_1.default.createElement(polaris_1.TextStyle, { variation: 'subdued' }, "An order that is in transit and has not received an update within a specified timeframe"),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: 'stalled-last-updated' },
                                react_1.default.createElement(styles_1.TextFieldContainer, null,
                                    react_1.default.createElement(polaris_1.TextField, { autoComplete: 'off', disabled: updating, error: transitIntervalFieldError !== null && transitIntervalFieldError !== void 0 ? transitIntervalFieldError : undefined, label: 'Stalled timeframe:', min: 1, onChange: (value) => {
                                            dispatch({
                                                type: 'LAST_UPDATE_TRANSIT_INTERVAL',
                                                payload: value
                                            });
                                        }, onFocus: () => setTransitIntervalFieldError(null), suffix: 'hours', type: 'number', value: lastScannedIntervalHours() }))),
                            react_1.default.createElement(styles_1.CheckBoxContainer, null,
                                react_1.default.createElement(polaris_1.Checkbox, { checked: transitExclusionList === null || transitExclusionList === void 0 ? void 0 : transitExclusionList.includes(6), label: 'Exclude Saturdays', onChange: (checked) => {
                                        const actionType = checked
                                            ? 'LAST_UPDATE_TRANSIT_ADD_EXCLUSION'
                                            : 'LAST_UPDATE_TRANSIT_REMOVE_EXCLUSION';
                                        dispatch({
                                            type: actionType,
                                            payload: 6
                                        });
                                    } }),
                                react_1.default.createElement(polaris_1.Checkbox, { checked: transitExclusionList === null || transitExclusionList === void 0 ? void 0 : transitExclusionList.includes(7), label: 'Exclude Sundays', onChange: (checked) => {
                                        const actionType = checked
                                            ? 'LAST_UPDATE_TRANSIT_ADD_EXCLUSION'
                                            : 'LAST_UPDATE_TRANSIT_REMOVE_EXCLUSION';
                                        dispatch({
                                            type: actionType,
                                            payload: 7
                                        });
                                    } })))),
                    react_1.default.createElement(styles_1.ControlsContainer, null,
                        react_1.default.createElement(polaris_1.Button, { disabled: updating, primary: true, submit: true }, "Save"))))))));
};
exports.ProblemOrdersRules = ProblemOrdersRules;
